var toggleTabIndex = function(thingy) {
	if (thingy.tabIndex === 0) {
		thingy.tabIndex = -1;
	}
	else {
		thingy.tabIndex = 0;
	}
};

export default toggleTabIndex;
